import { useOutletContext } from 'react-router-dom'
import type { SiteContext } from '../components/MainLayout'
import { ButtonLink } from '../components/ui'
import { routeFor } from '../config/routes'
import { usePageMeta } from '../hooks/usePageMeta'

export default function StatusPageV2({ type }: { type: 'thankYou' | 'notFound' }) {
  const { language, copy } = useOutletContext<SiteContext>()
  const page = copy[type]
  usePageMeta({ language, title: page.eyebrow, description: page.text })
  return <section className="status-page shell"><div className="status-page__mark" aria-hidden="true">FM</div><p className="eyebrow">{page.eyebrow}</p><h1>{page.title}</h1><p>{page.text}</p><ButtonLink to={routeFor(language)} variant="outline">{copy.common.backHome}</ButtonLink></section>
}
